export default __webpack_public_path__ + "static/media/STL_Fiscal_22.fadcf8df.pdf";